import { Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";

import lo2 from "../../../assets/images/CustomersPartners/lo2.webp";
import lo3 from "../../../assets/images/CustomersPartners/lo3.webp";
import lo4 from "../../../assets/images/CustomersPartners/lo4.webp";
import lo5 from "../../../assets/images/CustomersPartners/lo5.webp";
import lo7 from "../../../assets/images/CustomersPartners/lo7.webp";
import Parnet3 from "../../../assets/images/CustomersPartners/Parnet3.webp";
import Parnet4 from "../../../assets/images/CustomersPartners/Parnet4.webp";
import sp from "../../../assets/images/Footer/sp.svg";
import logoc from "../../../assets/images/CustomersPartners/logoc.webp";
import doitac1 from "../../../assets/images/CustomersPartners/doitac1.webp";
import doitac2 from "../../../assets/images/CustomersPartners/doitac2.webp";

export default function CusPart() {
  const images = [Parnet3, Parnet4, logoc, doitac1,doitac2, ,lo7, lo4, lo5, lo3, lo2];

  // Chia mảng thành nhóm cho mobile
  const chunkArray = (arr, size) => {
    const chunkedArr = [];
    for (let i = 0; i < arr.length; i += size) {
      chunkedArr.push(arr.slice(i, i + size));
    }
    return chunkedArr;
  };

  const mobileChunks = chunkArray(images, 4);

  return (
    <div className="w-full">
      <div className="container mx-auto px-5 py-12 flex flex-col gap-4">
        {/* Header */}
        <div className="flex items-center justify-center gap-2 flex-col">
          <div className="flex flex-row items-center gap-2">
            <img src={sp} alt="spl" className="hidden md:block" />
            <p className="text-2xl md:text-[32px] text-blue-600 font-semibold text-center">
              ĐỐI TÁC CỦA CHÚNG TÔI
            </p>
          </div>

          <p className="md:text-[20px] font-medium hidden md:block">
            Đồng hành cùng +1000 trung tâm trên toàn quốc
          </p>
        </div>

        {/* Hiển thị trên md+ theo grid 4 cột */}
        <div className="hidden md:grid md:grid-cols-4 md:gap-6 bg-gray-50 px-8 py-6">
          {images.map((src, idx) => (
            <div key={idx} className="flex justify-center mb-6">
              <img
                src={src}
                alt={`Logo ${idx + 1}`}
                className="max-w-[65%] h-auto object-cover rounded-[16px]"
              />
            </div>
          ))}
        </div>
       

        {/* Swiper cho mobile không pagination */}
        <div className="md:hidden bg-gray-50 px-6 py-6">
          <Swiper
            modules={[Pagination]}
            spaceBetween={20}
            slidesPerView={1}
            pagination={{ clickable: true, type: "bullets" }}
          >
            {mobileChunks.map((chunk, index) => (
              <SwiperSlide key={index}>
                <div className="grid grid-cols-2 gap-4">
                  {chunk.map((src, idx) => (
                    <div key={idx} className="flex justify-center">
                      <img
                        src={src}
                        alt={`Logo ${idx + 1}`}
                        className="w-full h-auto object-cover"
                      />
                    </div>
                  ))}
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </div>
  );
}
